module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_04_1280_1280_zh-hant-2757569004be2c5d709eefac12de87f9.jpg";